import { STEP_ORDER } from '@config/formSteps';
import { getThemes } from '../api';

/**
 *
 * @param {int|string} id
 * @returns training
 */
export const findFormationByFormationBitrixId = async (id) => {
  const themes = await getThemes();
  const targetId = parseInt(id, 10);

  // Recherche de la formation
  return (
    themes
      .flatMap((theme) => theme.formations || [])
      .find((f) => f?.id_formation_bitrix === targetId) || null
  );
};

export const getConsentPhrases = () => {
  return {
    1: {
      id: 1,
      key: 'consentContact',
      phrase:
        "J'accepte que L'École Française utilise les données renseignées dans ce formulaire pour me contacter et suivre mon dossier",
    },
    2: {
      id: 2,
      key: 'consentPartners',
      phrase:
        "J'accepte de recevoir par email des offres commerciales et informations de la part de L'École Française",
    },
  };
};

export const toLocalStorage = (fields) => {
  if (Object.entries(fields).length) {
    Object.entries(fields).map((field) => {
      if (!['consentContact', 'consentPartners'].includes(field[0])) {
        setStorageItem(field[0], field[1]);
      }
    });
  }
};

/**
 * function pour cleaner un peu le localstorage
 *
 * à utiliser idéalement au début sur la page intro
 * et à la fin d'un submit sur une page multi
 */
export const cleanStorage = () => {
  try {
    localStorage.removeItem('localState');
    localStorage.removeItem('domainId');
    localStorage.removeItem('trainingId');
    localStorage.removeItem('idFormationBitrix');
    localStorage.removeItem('trainingName');
    localStorage.removeItem('etudes');
    for (const key of STEP_ORDER) {
      localStorage.removeItem(key);
    }
  } catch (error) {
    console.error(
      'Valeur de localState invalide ou corrompue dans le localStorage. Videz le localStorage.',
      error,
    );
  }
};
/**
 * finalement cette fonction reset le loclastorage en retourne un localstorage vide au context au premier chargement
 * @returns
 */
export const validateOrResetLocalStorageOnIntroPage = () => {
  try {
    cleanStorage();
    return null;
  } catch (error) {
    console.error(
      'Valeur de localState invalide ou corrompue dans le localStorage. Videz le localStorage.',
    );
  }

  // rien n'a changé
  return null;
};

const setStorageItem = (key, value) => {
  const now = new Date();
  localStorage.setItem(
    key,
    JSON.stringify({
      value,
      expiry: now.getTime() + 432000, // 5j
    }),
  );
};
